import React from 'react';
import { Package, ShoppingCart, Edit2, Trash2 } from 'lucide-react';
import '../styles/ItemList.css';

const ItemList = ({ items, handleEdit, setShowDeleteConfirm, setViewingItem }) => {
  return (
    <div className="item-list-container">
      <h2 className="list-title">
        <Package size={28} color="#667eea" />
        Grocery Items ({items.length})
      </h2>

      {items.length === 0 ? (
        <div className="empty-state">
          <ShoppingCart size={64} className="empty-icon" />
          <p className="empty-title">No items yet</p>
          <p className="empty-subtitle">Add your first grocery item to get started</p>
        </div>
      ) : (
        <div className="table-wrapper">
          <table className="items-table">
            <thead>
              <tr className="table-header">
                <th className="th-first">ID</th>
                <th>Item</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Category</th>
                <th className="th-last">Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr
                  key={item.id}
                  className="table-row"
                  style={{ animationDelay: `${index * 0.1}s` }}
                  onClick={() => setViewingItem(item)}
                >
                  <td className="td-first td-id">
                    #{item.id}
                  </td>
                  <td className="td-name">
                    {item.name}
                  </td>
                  <td className="td-quantity">{item.quantity}</td>
                  <td className="td-price">
                    ₹{item.price.toFixed(2)}
                  </td>
                  <td className="td-category">
                    <span className={`category-badge ${item.category}`}>
                      {item.category.replace('-', ' ')}
                    </span>
                  </td>
                  <td className="td-last td-actions">
                    <div className="action-buttons">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEdit(item);
                        }}
                        className="btn-action btn-edit"
                      >
                        <Edit2 size={18} />
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowDeleteConfirm(item.id);
                        }}
                        className="btn-action btn-delete"
                      >
                        <Trash2 size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ItemList;